import type { WebChatErrorDetail, WebChatEventListener, WebChatEventName } from './types';

export function createEventBus() {
  const listeners = new Map<WebChatEventName, Set<WebChatEventListener>>();

  return {
    addEventListener(event: WebChatEventName, listener: WebChatEventListener): void {
      if (!listeners.has(event)) {
        listeners.set(event, new Set());
      }
      listeners.get(event)?.add(listener);
    },
    removeEventListener(event: WebChatEventName, listener: WebChatEventListener): void {
      listeners.get(event)?.delete(listener);
    },
    emit(event: WebChatEventName, detail?: WebChatErrorDetail): void {
      listeners.get(event)?.forEach((listener) => listener(detail));
    },
  };
}
